import React from "react"
import { useState, useEffect } from "react"
export const PageNavigator = ({page, setPage, totalPages}) => {


    // const nextPage = () => {
    //     setPage(page + 1)
    //     console.log(setPage);
    // }

    return (
        <>
        <div className="page-nav-container">
            <button
            onClick={() => {setPage(page - 1)}}
            disabled={page === 1}
            >
            Poprzednia
            </button>
            <span> Strona {page} z {totalPages} </span>
            <button
            onClick={() => {setPage(page + 1)}}
            disabled={page === totalPages}
            >
            Następna
            </button>
        </div>
        </>
    )
}